<template>
  <div class="member-page">
    <div class="overflow-hidden">
      <div>
        <div class="member-content member-profile">
          <a-anchor :offsetTop="0">
            <div class="profile-toolbar">
              <h2>个人信息</h2>
              <div class="profile-actions">
                <a-button type="primary" v-if="disabled" @click="disabled = false" icon="form">
                  修改个人信息</a-button
                >
                <template v-else>
                  <a-button v-if="info.id > 0" type="default" @click="cancel" icon="undo"
                    >取消修改</a-button
                  >
                  <a-button type="primary" @click="submit" icon="save" :loading="btnLoading">
                    保存</a-button
                  >
                </template>
                <a-button class="member-secondary" @click="visible = true"> 修改密码 </a-button>
              </div>
            </div>
          </a-anchor>
          <a-spin :spinning="spinning">
            <div class="profile-form">
              <a-form :form="form" v-bind="formItemLayout">
                <a-form-item label="昵称">
                  <a-textarea
                    v-decorator="[
                      'name',
                      {
                        rules: [{ required: !disabled, message: '请输入昵称' }],
                      },
                    ]"
                    :disabled="disabled"
                    autoSize
                  ></a-textarea>
                </a-form-item>
                <a-form-item label="真实姓名">
                  <a-input
                    v-decorator="[
                      'real_name',
                      {
                        rules: [{ required: false, message: '请输入真实姓名' }],
                      },
                    ]"
                    :disabled="disabled"
                    placeholder="请填写真实姓名"
                  ></a-input>
                </a-form-item>
                <a-form-item label="开户行">
                  <a-textarea
                    v-decorator="[
                      'bank_name',
                      {
                        rules: [{ required: false, message: '请输入开户行' }],
                      },
                    ]"
                    :disabled="disabled"
                    autoSize
                  ></a-textarea>
                </a-form-item>
                <a-form-item label="银行账号">
                  <a-textarea
                    v-decorator="[
                      'bank_account',
                      {
                        rules: [{ required: false, message: '请输入银行账号' }],
                      },
                    ]"
                    :disabled="disabled"
                    autoSize
                  ></a-textarea>
                </a-form-item>
                <a-form-item label="手机号">
                  <a-input
                    v-decorator="[
                      'receive_phone',
                      {
                        rules: [{ required: false, message: '请输入手机号' }],
                      },
                    ]"
                    :disabled="disabled"
                    placeholder="请输入手机号"
                  ></a-input>
                </a-form-item>
                <a-form-item label="身份证号码">
                  <a-textarea
                    v-decorator="[
                      'idcard_num',
                      {
                        rules: [{ required: false, message: '请输入身份证号码' }],
                      },
                    ]"
                    :disabled="disabled"
                    autoSize
                  ></a-textarea>
                </a-form-item>
              </a-form>
              <div v-if="!disabled" class="profile-consent">
                <a-checkbox v-model="privacyAgreed">我已阅读并同意</a-checkbox>
                <LoginPolicymodel />
              </div>
            </div>
          </a-spin>
        </div>
      </div>
    </div>
    <PasswdForm
      :phone="info.phone_number"
      :id="info.id"
      :visible="visible"
      @cancel="visible = false"
    ></PasswdForm>
  </div>
</template>
<script>

  import { userinfo, user_info } from '@/api/user';
  import PasswdForm from './module/passwdForm.vue';
  import { profileFormValues } from '@/utils/profilePrivacy';
  import LoginPolicymodel from '@/components/LoginPolicymodel/Policymodel.vue';
  import { isSessionExpiredError } from '@/utils/session';

  export default {
    components: { PasswdForm, LoginPolicymodel },
    data() {
      return {
        info: {},
        disabled: true,
        formItemLayout: { labelCol: { span: 6 }, wrapperCol: { span: 14 } },
        form: this.$form.createForm(this, { name: 'profile' }),
        spinning: false,
        btnLoading: false,
        visible: false,
        privacyAgreed: false,
        profileRequest: 0,
      };
    },
    activated() {
      this.getInfo();
    },
    deactivated() {
      this.profileRequest++;
      this.visible = false;
    },
    watch: {
      '$store.state.user.sessionVersion'() {
        this.profileRequest++;
        this.info = {};
        this.disabled = true;
        this.visible = false;
        this.privacyAgreed = false;
        this.spinning = false;
        this.btnLoading = false;
        this.form.resetFields();
      },
      disabled() {
        if (!this.disabled) this.privacyAgreed = false;
        this.$nextTick(this.fillProfileForm);
      },
    },
    methods: {
      fillProfileForm() {
        this.form.setFieldsValue(profileFormValues(this.info, this.disabled));
      },
      async getInfo() {
        const request = ++this.profileRequest;
        const version = this.$store.state.user.sessionVersion;
        this.spinning = true;
        try {
          const info = (await userinfo()) || {};
          if (request !== this.profileRequest || version !== this.$store.state.user.sessionVersion) return;
          this.info = info;
          this.disabled = true;
          await this.$nextTick();
          if (request === this.profileRequest && version === this.$store.state.user.sessionVersion) this.fillProfileForm();
        } catch (error) {
          if (request === this.profileRequest && version === this.$store.state.user.sessionVersion && !isSessionExpiredError(error)) {
            this.$message.error(error.message || String(error));
          }
        } finally {
          if (request === this.profileRequest) this.spinning = false;
        }
      },
      submit(e) {
        e.preventDefault();
        if (this.disabled || this.btnLoading) return;
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (err) return;
          if (!this.privacyAgreed) {
            this.$message.error('请先阅读并同意《用户协议》和《隐私政策》');
            return;
          }
          this.btnLoading = true;
          const version = this.$store.state.user.sessionVersion;
          try {
            await user_info({ id: this.info.id, version: this.info.version, ...values, privacy_agreed: true });
            if (version !== this.$store.state.user.sessionVersion) return;
            this.$message.success('保存成功');
            await this.$store.dispatch('user/getUserInfoAction');
            await this.getInfo();
          } catch (error) {
            if (version === this.$store.state.user.sessionVersion && !isSessionExpiredError(error)) {
              this.$error({ title: '错误提示', content: error.message || String(error) });
            }
          } finally {
            this.btnLoading = false;
          }
        });
      },
      cancel() {
        this.disabled = true;
        this.fillProfileForm();
      },
    },
  };
</script>
<style scoped>
.profile-consent { display:flex; align-items:center; margin-top:16px; color:#666; }
</style>
